import { render, staticRenderFns } from "./BindUserToTicketForm.vue?vue&type=template&id=5e23ed15&"
import script from "./BindUserToTicketForm.vue?vue&type=script&lang=js&"
export * from "./BindUserToTicketForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports